import closest from './lib/closest';
import delegate from './lib/delegate';
import dispatch from './lib/dispatch';
import getAttributes from './lib/get-attributes';
import matches from './lib/matches';
import parents from './lib/parents';
import parseUrl from './lib/parse-url';

export {
  closest,
  delegate,
  dispatch,
  getAttributes,
  matches,
  parents,
  parseUrl,
};



// WEBPACK FOOTER //
// ./~/dom-utils/index.js